import React from 'react';
import { wrapper } from '@/redux/store';
import AppLayout from '@/components/AppLayout';
import VisitConsult from '@/feat-components/VisitConsult';

interface VisitConsultRequestPageProps {
  shopId: number;
}

const VisitConsultRequestPage = (props: VisitConsultRequestPageProps) => {
  return <AppLayout isGnbExist={false} content={<VisitConsult {...props} />} />;
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ query: { shopId } }) => {
      if (!shopId) {
        return {
          redirect: {
            destination: '/error',
            permanent: false,
          },
        };
      }

      return {
        props: {
          shopId: shopId || null,
        },
      };
    },
);

export default VisitConsultRequestPage;
